import * as components from './components'

export default [
  {
    path: '/coach/tracker',
    component: components.CoacheeTracker,
    name: 'coacheeTracker',
    props: true
  },
  {
    path: '/coach/tracker/detail/:uuid',
    component: components.CoacheeDetail,
    name: 'coacheeDetail',
    props: true
  },
  {
    path: '/coach/assignment',
    component: components.CoacheeAssignment,
    name: 'coacheeAssignment',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/coacheeTracker/routes.js